<!-- 线上基础类别 -->
<template>
  <div class="class-fa">
    <div class="class-lf">
      <div class="l-title">
        线下类别
      </div>
      <dyhOnlineclass ref="dyhOnlineclassRef" who="offline" :btnshow="false"></dyhOnlineclass>
    </div>
    <div class="r-body">
      <div class="l-title">
        新建类别
      </div>
      <div class="card-right">
        <el-form ref="form" :model="class_data" label-width="150px">
          <el-form-item label="类别：">
            <el-input placeholder="" v-model="class_data.classify_no" maxlength="6" show-word-limit>
              <!-- <template slot="prepend">{{ my_self }}</template> -->
            </el-input>
          </el-form-item>

          <el-form-item label="类别名称：">
            <el-input v-model="class_data.classify_name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onSubmit()">新建类别</el-button>
            <br />
            <div style="color:#606266;">
              <!-- 新建类别不需要填写本级目录，修改类别需要填写本级目录。 -->
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// import systemcs from "@/components/systemcs.vue";
import dyhOnlineclass from "@/components/dyh-onlineclass.vue";
import { classifyList } from "@/api/merchant.js";
import { offlineGenerateClass } from "@/api/offlinestores.js";
export default {
  name: "onlinebaseclassinfo",
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    },
    "class_data.parent_no": {
      handler(np, op) {
        this.spClassNo(np);
        this.my_self = np;
      }
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      allClassList: [],
      scroll_height: "",
      my_self: "",
      class_data: {
        classify_no: "",
        classify_name: ""
      }
    };
  },
  components: { dyhOnlineclass },
  async mounted() {
    this.getClassifyList();
  },
  methods: {
    async getClassifyList() {
      this.allClassList = [];
      const res = await classifyList();
      this.allClassList = res;
    },
    async onSubmit() {
      const res = await offlineGenerateClass(this.class_data);
      if (this.testR(res)) {
        if (res.data.resp_data && res.data.resp_data.isSuccess) {
          this.successMessage(res.data.resp_data.msg);
          this.$refs.dyhOnlineclassRef.getClassifyList();
        } else if (res.data.resp_data && !res.data.resp_data.isSuccess) {
          this.successMessage(res.data.resp_data.msg);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.class-lf {
  padding-left: 30px;
}

.class-fa {
  width: 100%;
  height: 100%;
  display: flex;
}

.l-title {
  height: 40px;
  font-size: 20px;
  line-height: 2;
  padding: 0 0 10px 20px;
}

.r-body {
  width: calc(100% - 500px);
}

.card-right {
  width: auto;
  max-width: 600px;
  height: auto;
  /* background: rgb(205, 230, 255); */
  padding: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
